<!-- 全景专区 -->
<template>
  <div class='inside-component'>
    <!-- 上滑加载组件 -->
    <cp-page-scroll
      v-show="courseList.length"
      @load="load"
      :upFinish="upFinish"
      :isref="isref"
      ref="pageScroll"
    >
      <div class="course-list">
        <div class="course-item" v-for="(item,index) in courseList" :key="index">
          <img :src="formatAliyunPath(item.listImg)" :alt="item.name"/>
          <div class="masking"></div>
          <div class="item">
            <p class="title" v-text="item.name"></p>
            <div class="btn" @click="jumpUrl(item.jumpUrl)">遨游全景</div>
          </div>
        </div>
      </div>
    </cp-page-scroll>
  </div>
</template>

<script>
import { course, aliyun } from '@/agent'
export default {
  name: 'OverallViewCourse',
  props: {
  },
  data () {
    return {
      courseList: [],
      params: {
        pageNum: 1,
        pageSize: 10
      },
      upFinish: false, // 是否已加载全部
      isref: true, // 节流
    }
  },
  components: {},
  computed: {},
  mounted () {
    this.getPannoPageList()
  },
  methods: {
    // 获得vr专区 场景模块  获取场景列表分页
    getPannoPageList (resetList = false) {
      this.$loading.show()
      let params = {
        pageNum: this.params.pageNum,
        pageSize: this.params.pageSize,
        query: {},
        sorts: [
          {
            sortPropertyName: 'orderNbr',
            sortType: 'ISNULL'
          },
          {
            sortPropertyName: 'orderNbr',
            sortType: 'ASC'
          },
          {
            sortPropertyName: 'modifyTime',
            sortType: 'DESC'
          }
        ]
      }
      course.getPannoPageList(params).then(res => {
        if (res.code == 100) {
          this.$loading.hide()
          this.courseList = resetList ? res.data.list : [...this.courseList, ...res.data.list]
          if (this.params.pageNum >= res.data.pages) {
            this.upFinish = true
            this.isref = false
          } else {
            this.params.pageNum += 1
            this.upFinish = false
            this.isref = true
          }
        } else {
          this.isref = false // 请求失败下次不可以请求
          this.upFinish = true// 显示 没有更多了
        }
        this.$refs.pageScroll.hideLoading() // 底部加载loading隐藏
      })
    },
    load () {
      // 防止多次上滑动导致page等于2没加载出来就加载page等于3的内容
      this.getPannoPageList()
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
    jumpUrl (link) {
      window.open(link, '_blank')
    }
  }
}

</script>
<style lang='scss' scoped>
.inside-component{
  width:100%;
  background: #060A13;
  padding: 20px 0;
  .course-item{
    width: 100%;
    height: 115px;
    background: #000000;
    margin-bottom: 15px;
    position: relative;
    .masking{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.4);
    }
    img{
      width: 100%;
      height: 100%;
      display: block;
    }
    .item{
      position: absolute;
      top:50%;
      left: 50%;
      transform: translate(-50%,-50%);
      color: #FFFFFF;
      width:100%;
      .title{
        font-size: 20px;
        font-family: YouSheBiaoTiHei, YouSheBiaoTiHei-Regular;
        font-weight: 400;
        color: #FFFFFF;
        margin-bottom: 12px;
        text-align: center;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .btn{
        width: 70px;
        height: 24px;
        background: #E50914;
        border-radius: 1px;
        text-align: center;
        line-height: 24px;
        margin: 0 auto;
      }
    }
  }
  .course-item:last-child{
    margin-bottom: 0;
  }
}
</style>
<style lang='scss'>
</style>
